import React, {useRef} from 'react';
import classnames from 'classnames';
import IPfStickyHeader from './pfStickyHeader.d';
import styles from '../../stickyHeader/stickyHeader.scss';
import NewsLetterPromotion from '../../newsLetterPromotion/newsLetterPromotion';
import * as helper from '../../../Common/html-helper';

function PfStickyHeader({ renderNLP, nlpIsVisibleByParentRules, 
    isEsApp, isGlobal, children, gridRef }: React.PropsWithChildren<IPfStickyHeader>) {
    const [newsLetterVisible, setNewsLetterVisible] = React.useState(false);

    const customStyles = { top: 50 };
    let newsLetterPromotionTimer: ReturnType<typeof setTimeout>;
    const nlpHoverInProgressRef = useRef(false);

    if (isEsApp) {
        customStyles.top = 0;
    } else if (isGlobal) {
        customStyles.top = 90;
    }

    const hideNewsLetterPromotion = ()=> {
        // avoid new timer during hover and scroll:
        if(nlpHoverInProgressRef.current === false) {
            newsLetterPromotionTimer = setTimeout(() => {
                // only if we are not scrolling but hovering on nlp:
                if(nlpHoverInProgressRef.current === false)
                    setNewsLetterVisible(false);
            }, 2000);
        }
    };

    const handleNlpVisibilityTimeOut = () => {
        const articleGridBottom = gridRef.current?.getBoundingClientRect().bottom || 0;

        if (articleGridBottom <= 750) {
            setNewsLetterVisible(false);
        } else {
            if (renderNLP) {
                clearTimeout(newsLetterPromotionTimer);
                setNewsLetterVisible(true);
                hideNewsLetterPromotion();
            }
        }
    };

    const handleHoverOnNewsLetterFloater = () => {
        nlpHoverInProgressRef.current = true;
    };

    const handleEndHoverOnNewsLetterFloater = () => {
        nlpHoverInProgressRef.current = false;
        hideNewsLetterPromotion();
    }

    const throttleNlpVisibilityTimeOut = helper.throttle(handleNlpVisibilityTimeOut, 300);

    React.useEffect(() => {
        window.addEventListener('scroll', throttleNlpVisibilityTimeOut);

        return () => {
            window.removeEventListener('scroll', () => {throttleNlpVisibilityTimeOut;});
        };
    }, []);

    return (
        <div
            className={classnames(styles.sticky_header, styles.pf_result, { [styles.es_app]: isEsApp })}
            style={customStyles}
        >
            <div
                className={styles.content}
            >
                {children}
            </div>
            {renderNLP &&
                <div data-testid="newsLetterPromotion" data-semantic-id="newsLetterPromotion"
                     onPointerOver={handleHoverOnNewsLetterFloater}
                     onMouseEnter={handleHoverOnNewsLetterFloater}
                     onMouseLeave={handleEndHoverOnNewsLetterFloater}>
                    <NewsLetterPromotion isVisible={nlpIsVisibleByParentRules && newsLetterVisible}/>
                </div>
                }
        </div>
    );
}

export default PfStickyHeader;

